import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthProvider";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import "./fonts/0c28006f19928dfd146027cfd7024ca0.woff2";
import "./fonts/07ecc0aa9ce268962dea7356eeff50a6.woff2";
import "./fonts/028b4cfdfab5d1049178e9b1eb42f49e.woff2";
import "./fonts/84d8d4c49f66a6a5abe1e0608ba764a2.woff2";
import "./fonts/e094dede1f515189f4972f03427ad6eb.woff2";
import { Capacitor } from "@capacitor/core";
import { QueryClientProvider } from "@tanstack/react-query";
import { MaintenanceGate } from "./components/Maintenance/MaintenanceGate";
import { MaintenanceLoadingScreen } from "./components/Maintenance/MaintenanceLoadingScreen";
import { queryClient } from "./queryClient";
import { installPreloadErrorReload } from "./utils/chunkReload";
import { fetchMaintenanceNotice } from "./utils/maintenanceNotice";
import { ClientType } from "./utils/models";
import axiosInstance from "./utils/networkWrapper";
import "./luxonConfig";
import { router } from "./router";

if (Capacitor.isNativePlatform()) {
	axiosInstance.defaults.headers.common["client-type"] = ClientType.MOBILE;
}

// Before the first render, so a lazy page that fails to load right away is covered too.
installPreloadErrorReload();

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

const root = createRoot(container);

// Read before the first render so the Suspense fallback below covers the wait instead of the app flashing in.
const initialMaintenanceNotice = fetchMaintenanceNotice();

root.render(
	<React.StrictMode>
		<Suspense fallback={<MaintenanceLoadingScreen />}>
			<MaintenanceGate initialNotice={initialMaintenanceNotice}>
				<QueryClientProvider client={queryClient}>
					<SnackbarProvider>
						<AuthProvider>
							<RouterProvider router={router} />
						</AuthProvider>
					</SnackbarProvider>
				</QueryClientProvider>
			</MaintenanceGate>
		</Suspense>
	</React.StrictMode>,
);
